import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { DATA_PROTECTION_ACTION_TYPE } from "./data-protection.action";
import { DataProtectionState } from "./data-protection.model";

const INITIAL_STATE: DataProtectionState = {
	gdprEnabledCountries: undefined,
};

export function dataProtectionReducer(state = INITIAL_STATE, action: ActionWithPayload): DataProtectionState {
	switch (action.type) {
		case DATA_PROTECTION_ACTION_TYPE.getGdprEnabledCountriesSuccess: {
			return updateState(state, {
				gdprEnabledCountries: action.payload,
			});
		}
		default: {
			return state;
		}
	}
}
